module.exports = __webpack_public_path__ + "static/img/Main-Banner2.d46dd20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/banners/Main-Banner2.jpg
// module id = 5Xro
// module chunks = 1